import React from "react";
import { Chant } from "../../chants/Chant";
import { PointedSyllable, PointedWord } from "../../models";

export const LitanyLine: React.FC<{
    firstText: string;
    secondText: string;
    firstTone: string[];
    secondTone: string[];
}> = (props) => {
    const { firstText, secondText, firstTone, secondTone } = props;

    const firstWords: PointedWord[] = [];
    const secondWords: PointedWord[] = [];

    let firstToneIndex = 0;
    const fw = firstText.split(" ");
    fw.forEach((word, wordIndex) => {
        const pointedSyllables: PointedSyllable[] = [];

        const syllables = word.split("_");
        syllables.forEach((syllable, syllableIndex) => {
            if (firstToneIndex > 0 && firstToneIndex < firstTone.length - 1) {
                firstToneIndex++;
            }

            if (syllable[0] === "|") {
                firstToneIndex++;
                syllable = syllable.slice(1);
            }

            pointedSyllables.push({
                text: syllable,
                notes: [firstTone[firstToneIndex]],
                long:
                    wordIndex === fw.length - 1 &&
                    syllableIndex === syllables.length - 1,
                dotBefore: firstToneIndex === 1,
            });
        });

        firstWords.push({ syllables: pointedSyllables });
    });

    let secondToneIndex = 0;
    const sw = secondText.split(" ");
    sw.forEach((word, wordIndex) => {
        const pointedSyllables: PointedSyllable[] = [];

        const syllables = word.split("_");
        syllables.forEach((syllable, syllableIndex) => {
            if (
                secondToneIndex > 0 &&
                secondToneIndex < secondTone.length - 1
            ) {
                secondToneIndex++;
            }

            if (syllable[0] === "|") {
                secondToneIndex++;
                syllable = syllable.slice(1);
            }

            pointedSyllables.push({
                text: syllable,
                notes: [secondTone[secondToneIndex]],
                long:
                    wordIndex === sw.length - 1 &&
                    syllableIndex === syllables.length - 1,
                dotBefore: secondToneIndex === 1,
            });
        });

        secondWords.push({ syllables: pointedSyllables });
    });

    return (
        <Chant
            pointedText={{
                verses: [
                    firstText.length > 0
                        ? { firstHalf: firstWords, secondHalf: secondWords }
                        : { secondHalf: secondWords },
                ],
                clef: "f5",
            }}
            dropCap={false}
            boldMode="alternate halves"
            tone="2.1"
        />
    );
};
